import { useEffect, useState } from 'react'
import {
  Configuration,
  EcommerceOperationApi,
  OrdersListOperationResponseItem,
  SaleOrderStatusEnum,
} from 'generated/api'
import { axiosDefaultConfig } from 'constants/axios'

const axiosConfig = new Configuration(axiosDefaultConfig)
const ecommerceOperationApi = new EcommerceOperationApi(axiosConfig)

export interface IUseOrderCancellation {
  loading: boolean
  setLoading: (payload: boolean) => void
  fetchData: () => Promise<void>
  data: OrdersListOperationResponseItem[]
  failed: boolean
  totalRows: number
  limit: number
  page: number
  selectedOrder: OrdersListOperationResponseItem | null
  setSelectedOrder: (payload: OrdersListOperationResponseItem | null) => void
  setLimit: (limit: number) => void
  setPage: (page: number) => void
  confirmOrder: (isApproved: boolean) => void
}

export const useOrderCancellation = () => {
  const [selectedOrder, setSelectedOrder] = useState<OrdersListOperationResponseItem | null>(null)
  const [loading, setLoading] = useState(true)
  const [failed, setFailed] = useState(false)
  const [data, setData] = useState<OrdersListOperationResponseItem[]>([])
  const [totalRows, setTotalRows] = useState(0)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const status = SaleOrderStatusEnum.CancelApproval

  useEffect(() => {
    fetchData()
  }, [page, limit])

  const fetchData = async (): Promise<void> => {
    try {
      setLoading(true)
      setFailed(false)
      const { data } = await ecommerceOperationApi.ordersListOperation(page, limit, status)
      setData(data.items)
      setTotalRows(data.pagination.total)
      setLoading(false)
    } catch (e) {
      setFailed(true)
      setLoading(false)
    }
  }

  const confirmOrder = async (isApproved: boolean) => {
    if (selectedOrder) {
      return await ecommerceOperationApi.ordersCancelConfirmation(
        selectedOrder?.id ?? '',
        'ADMIN_WEB',
        { isApproved },
      )
    }
    return true
  }

  return {
    loading,
    setLoading,
    failed,
    setFailed,
    data,
    setData,
    totalRows,
    setTotalRows,
    page,
    setPage,
    limit,
    setLimit,
    selectedOrder,
    setSelectedOrder,
    fetchData,
    status,
    confirmOrder,
  }
}
